import { gql } from '@apollo/client'

import { SHOP_ADDRESS_FRAGMENT } from './address'

export const SHOP_RECIPIENT_FRAGMENT = gql`
  fragment ShopRecipient on ShopRecipient {
    address {
      ...ShopAddress
    }
    customerNickname
    email
    id
    nickname
    note
    scheduledAt
    sendingType
  }
  ${SHOP_ADDRESS_FRAGMENT}
`
